import { createSelector } from '@reduxjs/toolkit';
import { selectBulk } from '../../selectors';
import { BulkState } from '../../types';

export const selectCommon = createSelector(selectBulk, (bulkState: BulkState) => bulkState.common);
export const selectAfsls = createSelector(selectCommon, (common) => common.afsls.afsls);
